import * as httpAgent from 'utils/http'
import link from '@/utils/link/link'
/**
 * @method: 获取缩略版sop
 * @param {type} 
 * @return: 
 */
export function handleSopCustomerService(params, options) {
  return httpAgent.POST('/yunjixinyunadmin/admin/xinyun/csRobot/handleWithSopWorkFlowSimple', params, options)
}


// /***
//  * 新版申请补偿-获取补偿列表
//  * **/
export function preViewCompensateOrderItem(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.POST('/refundadmin/admin/compensateV2/preViewCompensateOrderItem', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/admin/compensateV2/preViewCompensateOrderItem`, params, options)
}

/**
 * @method: 查询订单列表
 * @param {type} 
 * @return: 
 * @Author: 陈长吉（chencj@yunjiglobal.com）
 * @Date: 2019-10-14 15:24:53
 */
export function getOrder(params, options) {
  return httpAgent.POST('/yunjixinyunadmin/admin/xinyun/crm/v2/orderInfo', params, { ...options, timeout: 6000 })
}

/**
 * @method: 获取留言sop下拉框
 * @param {type} 
 * @return: 
 * @Author: 陈长吉（chencj@yunjiglobal.com）
 * @Date: 2019-10-14 15:24:53
 */
export function getLeaveMsgSopApi(params, options) {
  return httpAgent.POST('/yunjixinyunadmin/admin/xinyun/leaveMsg/getLeaveMsgSop', params, { ...options, timeout: 6000 })
}

/**
 * @method: 提交缓存表单
 * @param {type} 
 * @return: 
 * @Author: 陈长吉（chencj@yunjiglobal.com）
 * @Date: 2019-10-14 15:24:53
 */
export function handleDraftCacheApi(params, options) {
  return httpAgent.POST('/yunjixinyunadmin/admin/xinyun/leaveMsg/handleDraftCache', params, { ...options, timeout: 6000 })
}

/**
 * @method: 提交能力表单内容
 * @param {type} 
 * @return: 
 * @Author: 陈长吉（chencj@yunjiglobal.com）
 * @Date: 2019-10-14 15:24:53
 */
export function handleMsgContentCacheApi(params, options) {
  return httpAgent.POST('/yunjixinyunadmin/admin/xinyun/leaveMsg/handleMsgContentCache', params, { ...options, timeout: 6000 })
}

/**
 * @method: 一二线工作台留言创建
 * @param {type} 
 * @return: 
 * @Author: 陈长吉（chencj@yunjiglobal.com）
 * @Date: 2019-10-14 15:24:53
 */
export function submitLeaveMsgApi(params, options) {
  return httpAgent.POST('/yunjixinyunadmin/admin/xinyun/leaveMsg/submitLeaveMsg', params, { ...options, timeout: 6000 })
}
